<ul>
    <li *ngFor='let potato of potatoes' ><app-potato [potato]="potato"></app-potato></li>
</ul>
